<template>
    <button class="app-btn btn btn-light-dark">
        Extra Component
    </button>
</template>

<script setup></script>

<style lang="scss" scoped></style>
